// src/App.js (MainApp kısmı)
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Content from './components/Content';
import Login from './components/Login/Login';
import './App.css';

function MainApp() {
  const [activeItem, setActiveItem] = useState(() => {
    const stored = sessionStorage.getItem('activeItem');
    return stored !== null ? parseInt(stored) : 100;
  });

  const handleMenuClick = (index) => {
    setActiveItem(index);
    sessionStorage.setItem('activeItem', index);
  };

  const user = JSON.parse(sessionStorage.getItem('user'));

 const menuItems = [];

if ((user && user.role === 'admin') || (user && user.role === 'manager')) {
  menuItems.push({ id: 0, label: 'Form' });
}
menuItems.push(
  // { id: 1, label: 'İzin' },
  { id: 2, label: 'Short Url' },
  { id: 3, label: 'Not' },
  { id: 4, label: 'Trend' },
  { id: 5, label: 'Brands' },
  { id: 6, label: 'Cuma Mailing' },
  { id: 7, label: 'Bilgilerim' }
);
if (user && user.role === 'admin') {
  menuItems.push(
    { id: 8, label: 'Yönetici' },
    { id: 9, label: 'Yetkiler' }
  );
}

  return (
    <div className="app-container">
      <Sidebar 
        menuItems={menuItems} 
        activeItem={activeItem} 
        onMenuItemClick={handleMenuClick} 
      />
      <Content 
        activeItem={activeItem} 
        onCenterItemClick={handleMenuClick} 
      />
    </div>
  );
}
// Giriş kontrolünü yapan Higher Order Component (HOC)
const PrivateRoute = ({ element }) => {
  const token = sessionStorage.getItem('authToken');
  return token ? element : <Navigate to="/login" />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/*" element={<PrivateRoute element={<MainApp />} />} />
      </Routes>
    </Router>
  );
}

export default App;
